import React from 'react';
import { Col, Div } from '../../../../grid';
import { ClearFix } from '../../../../typography';

const RenderIconBoxes = ({
  productTypePack,
  IconBoxes,
}) => (
  <React.Fragment>
    {productTypePack && (
    <React.Fragment>
      {IconBoxes && (
      <Col xs={12}>
        <Div>
          {IconBoxes()}
          <ClearFix />
        </Div>
      </Col>
      )}
    </React.Fragment>
    )}
  </React.Fragment>
);

export default RenderIconBoxes;
